import {
    FETCH_PROMOTION_PACKAGES_SUCCESS,
    FETCH_MY_PROMOTIONS_SUCCESS,
    FETCH_AVAILABLE_SPACES_SUCCESS,
    CLEAR_AVAILABLE_SPACES,
    PROMOTION_LOADING,
    PROMOTION_ERROR,
    FETCH_PROMOTION_ANALYTICS_SUCCESS
} from './PromotionsActions';

const initialState = {
    packages: [],
    myPromotions: [],
    availableSpaces: [],
    loading: false,
    error: null
};

export const promotionsReducer = (state = initialState, action) => {
    switch (action.type) {
        case PROMOTION_LOADING:
            return { ...state, loading: true, error: null };
        case FETCH_PROMOTION_PACKAGES_SUCCESS:
            return { ...state, loading: false, packages: action.payload };
        case FETCH_MY_PROMOTIONS_SUCCESS:
            return { ...state, loading: false, myPromotions: action.payload };
        case FETCH_AVAILABLE_SPACES_SUCCESS:
            return { ...state, loading: false, availableSpaces: action.payload };
        case FETCH_PROMOTION_ANALYTICS_SUCCESS:
            return { ...state, loading: false }; // Clear loading on analytics success
        case CLEAR_AVAILABLE_SPACES:
            return { ...state, availableSpaces: [] };
        case PROMOTION_ERROR:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};
